import SharedFund from '@/models/SharedFund';
import SharedFundService from '@/services/SharedFundService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useSharedFundsStore = defineStore('shared_funds', {
  state: () => ({}),

  getters: {
    models: () => useRepo(SharedFund),
  },

  actions: {
    async fetchClaimIndex(projectId: Id) {
      const [data, error] = await SharedFundService.claimIndex(projectId);

      if(error) {
        throw error;
      }

      if(data) {
        this.models.save(data);
      }

      return data;
    },

    async create(projectGroupId: Id, request: ApiRequests['api.v1.project-groups.shared-funds.store']) {
      const [data, error] = await SharedFundService.create(projectGroupId, request);

      if(error) {
        throw error;
      }

      if(data) {
        this.models.save(data);
      }

      return data;
    },

    async update(id: Id, request: ApiRequests['api.v1.shared-funds.update']) {
      const [data, error] = await SharedFundService.update(id, request);

      if(error) {
        throw error;
      }

      if(data) {
        this.models.save(data);
      }

      return data;
    },

    async delete(id: Id) {
      const [data, error] = await SharedFundService.delete(id);

      if(error) {
        throw error;
      }

      this.models.destroy(id);

      return data;
    },
  },
});
